import MessagingApp from '../components/Messaging/MessagingApp'
import http from '../config/http'
import { use, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { checkWhatsAppConfig } from '../utils/whatsappHelper'
import { useAuth } from '../contexts/AuthContext'
import { AlertCircle } from 'lucide-react'

const Messaging = () => {
  const [data, setData] = useState([]);
  const [isConfigured, setIsConfigured] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const { userData } = useAuth();

  useEffect(() => {
    const checkConfig = async () => {
      // Get userData from localStorage if not in context yet
      const storedUserData = localStorage.getItem('userData');
      const user = userData || (storedUserData ? JSON.parse(storedUserData) : null);
      
      if (!user?.tenantId || !user?.userid) {
        console.error('No user data available');
        setLoading(false);
        setIsConfigured(false);
        return;
      }
      
      try {
        const configured = await checkWhatsAppConfig(user.tenantId, user.userid);
        setIsConfigured(configured);
        
        if (!configured) {
          setLoading(false);
          return;
        }
        
        // Only fetch contacts if WhatsApp is configured
        http.get('/api/messages/contacts').then((response) => {
          console.log(response.data);
          setData(response.data);
          setLoading(false);
        }).catch((error) => {
          console.error('Error fetching contacts:', error);
          setLoading(false);
        });
      } catch (error) {
        console.error('Error checking WhatsApp config:', error);
        setIsConfigured(false);
        setLoading(false);
      }
    };
    
    checkConfig();
  }, [userData]);

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  if (isConfigured === false) {
    return (
      <div className="flex items-center justify-center h-screen bg-gray-50 dark:bg-gray-900">
        <div className="max-w-md w-full mx-4">
          <div className="bg-white dark:bg-gray-800 rounded-lg shadow-lg p-8">
            <div className="flex items-center justify-center w-16 h-16 mx-auto mb-4 bg-red-100 dark:bg-red-900 rounded-full">
              <AlertCircle size={32} className="text-red-600 dark:text-red-400" />
            </div>
            <h2 className="text-2xl font-bold text-center text-gray-900 dark:text-white mb-2">
              WhatsApp No Configurado
            </h2>
            <p className="text-center text-gray-600 dark:text-gray-400 mb-6">
              Necesitas configurar WhatsApp antes de usar la mensajería. Por favor, ve a la configuración y añade tus credenciales de WhatsApp Business.
            </p>
            <button
              onClick={() => navigate('/settings')}
              className="w-full px-4 py-3 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-colors font-medium"
            >
              Ir a Configuración de WhatsApp
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div>
      <MessagingApp contacts={data}/>
    </div>
  )
}

export default Messaging